// extracted by mini-css-extract-plugin
export default {"modalBody":"deleteJobModal_modalBody__8qhFU"};